<template>
    <div class="partner" style="vertical-align: middle;text-align: center">
        <!-- ============= 顶部背景图 ============= -->
        <div>
            <img src="../../assets/images/partner/banner.png" style="width: 100%;display: block">
        </div>

        <!-- ============= 合作商家 ============= -->
        <div class="partner-merchants" style="height: 80px;line-height: 80px;text-align: center;width: 100%;background-color: #F0F0F0">
            <ul style="list-style-type:none;cursor:pointer;line-height: 80px;text-align: center;margin: 0 auto;padding: 0;height: 80px;width: 900px;background-color: #F0F0F0">
                <li v-for="(item,index) in items" :key="index" :class="{'selected':flag == index}" style="float: left;height: 80px;width: 450px;font-size: 24px" @click="getCompanyDetaile(index)">{{item.title}}</li>
            </ul>
        </div>

        <!-- ============= 合作商家背景图 ============= -->
        <div class="merchant-background-img">
            <img v-show="deJiTongShow" src="../../assets/images/dealer/Bitmap1.png">
            <img v-show="wanBaoGangShow" src="../../assets/images/partner/Bitmap.png" >
        </div>

        <!-- ============= 合作分割图 ============= -->
        <div class="merchant-img">
            <img src="../../assets/images/partner/Group2013.png" style="xmargin-left: 15%">
        </div>

        <!-- ============= 合作商家介绍 ============= -->
        <div style="height: 120px">
            <div class="dealer-location" style="height: 120px;text-align: center">
                <div style="padding-top: 40px">
                    <span >|</span>
                    <span style="margin-left: 40px;cursor: pointer" @click="reload">香港万保刚(IC博士)</span>
                    <span style="margin-left: 40px">|</span>
                    <span style="margin-left: 40px;cursor: pointer" @click="reload">台湾万保刚</span>
                    <span style="margin-left: 40px">|</span>
                    <span style="margin-left: 40px;cursor: pointer" @click="reload">IC MASTER SHOP(WHOLESALE / RETAIL) </span>
                    <span style="margin-left: 40px">|</span>
                    <span style="margin-left: 40px;cursor: pointer" @click="reload">MOBICON (TAIWAN) LIMITED </span>
                    <span style="margin-left: 40px">|</span>
                </div>
            </div>
        </div>

        <!-- ============= 分部表格 ============= -->
        <div class="local-department" style="display: inline-block">
            <div class="local-department-title">
              <div style="padding-top: 8px">深圳一部</div>
            </div>

            <div><el-divider></el-divider></div>

            <el-table
                :data="wanBaoGangList"
                border
                class="local-department-table">
                <el-table-column align="center" prop="address" width="360">
                    <template slot="header" slot-scope="scope">
                        <span class="talbe-span" style="font-size: 16px">Address</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="tel" width="180">
                    <template slot="header" slot-scope="scope">
                       <span class="talbe-span">Tel</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="fax">
                    <template slot="header" slot-scope="scope">
                       <span class="talbe-span">Fax</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="email">
                    <template slot="header" slot-scope="scope">
                        <span class="talbe-span">E-mail</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="contact">
                    <template slot="header" slot-scope="scope">
                        <span class="talbe-span">Contact</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="websitel" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="talbe-span">Websitel</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                deJiTongShow: false,
                wanBaoGangShow: true,
                flag: -1,
                wanBaoGangList: [],
                items: [{title:'深圳得技通电子有限公司'},{title:'万保刚公司'}],
                tableData7: [{
                    address: '7/F, No.586, Rui Guang Road, Nei-Hu District,Taipei 114,Taiwan, ROC. ',
                    tel: '886-2-2657 9336',
                    fax: '886-2-2657 8030',
                    email: ' tw@mobicon.com ',
                    contact: 'Ms Ann.',
                    websitel: 'www.mobicon.com.tw',
                }],
            }
        },
        mounted:function(){
            this.getCompanyDetaile(1);
            this.getWanBaoGangData();
        },
        methods: {
            getCompanyDetaile:function (index) {
                this.flag = index;
                console.log(index)
                if(index === 0){
                    this.deJiTongShow = true;
                    this.wanBaoGangShow = false;
                } else if (index === 1){
                    this.deJiTongShow = false;
                    this.wanBaoGangShow = true;
                }
            },
            reload:function () {
                window.location.reload();
            },
            getWanBaoGangData: function () {
                api.http_mock('/api/getWanBaoGangData')
                  .then(res => {
                    console.log("tableDataTest---->", res);
                    this.wanBaoGangList = res;
                  })
            },
        }
    }
</script>

<style>
    .partner .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}
    .partner .partner-merchant { height: 80px;width: 100%;line-height:30px;background-color: #F0F0F0;text-align: center }
    .partner .merchant-background-img { height: 120px;background-color: #F0F0F0;position: relative;padding-top: 40px }
    .partner .merchant-img { height: 80px;background-color: #F0F0F0;position: relative; }
    .partner .local-department { height: 240px;text-align: center;display: inline-block }
    .partner .local-department-title { background-color: rgba(239,245,255,1);width: 1200px;height: 40px; }
    .partner .local-department-table { width: 1200px;text-align: center; }
    .partner .local-department-table .talbe-span { font-size: 16px;color: rgba(51,51,51,1)  }
    .partner .partner-merchants-li:hover { background-color: #fff }
    .partner .selected { background-color: #fff }
</style>



// WEBPACK FOOTER //
// src/pages/dealer/partner.vue